//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 22.07.2015.
 * Updated by z004c7wn on 24.03.2025.
 */


(function () {
    'use strict';

    angular.module('container.widgets')
        .constant('BUSY_INDICATOR_TIMEOUT', 50)
        .directive('srsngBusyIndicatorOverlay', srsngBusyIndicatorOverlay);

    srsngBusyIndicatorOverlay.$inject = ['$rootScope', 'utilService', 'BUSY_INDICATOR_TIMEOUT'];
    
    function srsngBusyIndicatorOverlay($rootScope, utilService, BUSY_INDICATOR_TIMEOUT) {
        return {
            restrict: 'E',
            scope: {},
            templateUrl: 'container/ui/app/widgets/busy-indicator-overlay/busy-indicator-overlay.html',
            link: link
        };

        function link(scope, element, attrs) {
            scope.busy = false;
            let manuallyHandledCount = 0;
            let activePromises = [];
            let deregisterFunctions = [];

            deregisterFunctions.push(
                $rootScope.$on('handleBusyPromise', handleBusyPromise)
            );
            
            deregisterFunctions.push(
                $rootScope.$on('displayBusyIcon', displayBusyIcon)
            );
            
            deregisterFunctions.push(
                $rootScope.$on('hideBusyIcon', hideBusyIcon)
            );
            
            deregisterFunctions.push(
                $rootScope.$on('clearBusyIndicator', clearBusyIndicator)
            );

            scope.$on('$destroy', function() {
                deregisterFunctions.forEach(function(deregisterFn) {
                    deregisterFn();
                });
                clearAllTimeouts();
            });

            /**
             * Handles a promise and shows the busy indicator until it resolves
             * @param {Event} event - The Angular event object
             * @param {Promise} promise - The promise to track
             */
            function handleBusyPromise(event, promise) {
                if (!promise || typeof promise.finally !== 'function') {
                    console.warn('SrsngBusyIndicatorOverlay: Invalid promise provided to busy indicator');
                    return;
                }
                
                scope.busy = true;
                let promiseGuid = utilService.generateUuid();
                let timeoutId = null;
                
                addPromise(promiseGuid);
                
                // prevent infinite loading
                timeoutId = setTimeout(function() {
                    console.warn('SrsngBusyIndicatorOverlay: Promise timeout in busy indicator after ' + 
                                 (BUSY_INDICATOR_TIMEOUT) + ' seconds');
                    resolvePromise(promiseGuid);
                    updateBusyIndicator();
                }, BUSY_INDICATOR_TIMEOUT * 1000);
                
                // Store timeout ID with the promise for cleanup
                activePromises.find(p => p.promiseId === promiseGuid).timeoutId = timeoutId;
                
                promise
                    .catch(function(error) {
                        console.error('SrsngBusyIndicatorOverlay: Promise handled by busy indicator failed:', error);
                    })
                    .finally(function() {
                        let promiseObj = activePromises.find(p => p.promiseId === promiseGuid);
                        
                        if (promiseObj && promiseObj.timeoutId) {
                            clearTimeout(promiseObj.timeoutId);
                        }
                        
                        resolvePromise(promiseGuid);
                        updateBusyIndicator();
                        
                        if (!scope.$root.$$phase) {
                            scope.$apply();
                        }
                    });
            }

            /**
             * Manually shows the busy indicator
             */
            function displayBusyIcon() {
                scope.busy = true;
                manuallyHandledCount++;
            }

            /**
             * Manually hides the busy indicator
             */
            function hideBusyIcon() {
                manuallyHandledCount = Math.max(0, manuallyHandledCount - 1);
                updateBusyIndicator();
            }

            /**
             * Forcibly clears the busy indicator state
             */
            function clearBusyIndicator() {
                clearAllTimeouts();
                scope.busy = false;
                manuallyHandledCount = 0;
                activePromises = [];
            }

            /**
             * Clears all active timeouts
             */
            function clearAllTimeouts() {
                activePromises.forEach(function(promise) {
                    if (promise.timeoutId) {
                        clearTimeout(promise.timeoutId);
                    }
                });
            }

            /**
             * Adds a promise to the tracking array
             * @param {string} id - Unique ID for the promise
             */
            function addPromise(id) {
                activePromises.push({
                    promiseId: id, 
                    finished: false,
                    timeoutId: null
                });
            }

            /**
             * Marks a promise as resolved
             * @param {string} id - ID of the promise to resolve
             */
            function resolvePromise(id) {
                activePromises.forEach(function(promise) {
                    if (promise.promiseId === id) {
                        promise.finished = true;
                    }
                });
            }

            /**
             * Updates the busy indicator visibility based on current state
             */
            function updateBusyIndicator() {
                activePromises = activePromises.filter(function(promise) {
                    return !promise.finished;
                });
                
                if (activePromises.length === 0 && manuallyHandledCount === 0) {
                    scope.busy = false;
                }
            }
        }
    }
})();
